/* Global imports. */
import React from "react"
import { nanoid } from 'nanoid';
import BookSpotlightCollectionItem from "@components/BookSpotlightCollectionItem"
import { PanMacmillanEdition } from "@src/models/panmacmillan";

interface Props {
  title: string;
  introduction: string;
  bookSpotlights: any;
  itemsPerRow: string;
  editions?: PanMacmillanEdition[];
  displayDescription?: boolean;
  displayBuyButton?: boolean;
  displayAuthor?: boolean;
  componentID?: string;
  referringSlug?: string
}

const BookSpotlightCollection = ({ title, introduction, bookSpotlights, itemsPerRow, editions, displayAuthor, displayDescription, displayBuyButton, componentID, referringSlug  }: Props) => {

  const itemsPerRowClass = (() => {
    switch(itemsPerRow) {
      case "4":
        return "sm:w-1/4";
      case "3":
        return "sm:w-1/3";
      default: 
        return "sm:w-1/5";
    }
  })();

  return bookSpotlights && bookSpotlights.length > 0 && <> <section id={componentID} data-component="bookspotlight-collection" className="section--book-spotlight-collection pt-8">
  {
  (title || introduction ) &&
    <div>
      {title && 
      <h2 className="bookspotlight-collection--heading">{title}</h2>
      }
      {introduction && introduction !== "<p><br></p>" && 
      <div className="mb-8" dangerouslySetInnerHTML={{ __html: introduction && introduction }} />
      }
    </div>
  }
   
   <div className="bookspotlight-collection flex flex-wrap justify-center -mx-4 lg:-mx-8 lg:my-8 sm:mt-12 items-baseline">
      {bookSpotlights && bookSpotlights.map((item:any) => {
        const bookDetails = editions && editions.filter(edition => edition.node.isbn === item.elements.isbn.value.replace(/\s/g, ''))
        const filteredBookDescription = bookDetails &&  bookDetails[0] && bookDetails[0].node.textContents && bookDetails[0].node.textContents.filter(textContents => textContents.textType === "3")
        const isPanMacTitle = item.elements.is_this_a_pan_macmillan_book_.value && item.elements.is_this_a_pan_macmillan_book_.value[0] && item.elements.is_this_a_pan_macmillan_book_.value[0].codename && item.elements.is_this_a_pan_macmillan_book_.value[0].codename === "no" ? false : true;
        return (
           <div className={`w-1/2 ${itemsPerRowClass} px-4 pb-8 lg:px-8 lg:pb-12 flex`} key={nanoid()} >
            {isPanMacTitle ?
                (bookDetails && bookDetails[0] &&
                    <BookSpotlightCollectionItem 
                    title={bookDetails[0] && bookDetails[0].node.titleFull}
                    primaryAuthorName={bookDetails[0] && bookDetails[0].node.primaryContributorName} 
                    isbn={bookDetails[0].node.isbn.replace(/\s/g, '')} 
                    jacketImageRemote={bookDetails[0].node.sourceImagePath }
                    width={bookDetails[0].node.dimensions.width ? bookDetails[0].node.dimensions.width : null}
                    height={bookDetails[0].node.dimensions.height ? bookDetails[0].node.dimensions.height : null}
                    description={filteredBookDescription && filteredBookDescription[0] && filteredBookDescription[0].text !== '' ? filteredBookDescription[0].text : item.elements.alternative_book_description.value}
                    linkedItem={item.elements} 
                    displayDescription={displayDescription} 
                    displayBuyButton={displayBuyButton} 
                    displayAuthor={isPanMacTitle ? displayAuthor : item.elements.contributor_name.value} 
                    publicationDate={bookDetails[0].node.publicationDate && new Date(bookDetails && bookDetails[0].node.publicationDate)} 
                    imprint={bookDetails[0].node.imprintName} 
                    format={bookDetails[0].node.format} 
                    editionUrl={bookDetails[0].node.fields.slug}
                    referringComponentID={componentID}
                    isPanMacmillanTitle={isPanMacTitle}
                    referringSlug={referringSlug}
                    customURL={item.elements.customURL}
                    />
                )
                :
                (
                    <BookSpotlightCollectionItem 
                    title={item.elements.title.value}
                    primaryAuthorName={item.elements.contributor_name.value} 
                    isbn={item.elements.isbn.value} 
                    jacketImageRemote={item.elements.alternative_jacket_image.value[0].url } 
                    description={item.elements.alternative_book_description.value}
                    linkedItem={item.elements} 
                    displayDescription={displayDescription} 
                    displayBuyButton={displayBuyButton} 
                    displayAuthor={item.elements.contributor_name.value} 
                    publicationDate={new Date()} 
                    imprint={'Unknown'} 
                    format={'Unknown'} 
                    editionUrl={''}
                    referringComponentID={componentID}
                    isPanMacmillanTitle={isPanMacTitle}
                    referringSlug={referringSlug}
                    customURL={item.elements.customURL}
                    />
                )
            }
        </div>
        )
      })}
	  
    </div>
</section></>
};

export default BookSpotlightCollection;
